// @ts-strict-ignore
import { useTranslation } from "react-i18next";

import { l } from "@emerson/locales";
import { stripAttributesFromHTMLString } from "@shared/helpers/stripAttributesFromHTMLString";

import { GenericCollapsible } from "../GenericCollapsible/GenericCollapsible";

interface Props {
  dosageInstructions: string;
}

const SuggestedUse = ({ dosageInstructions }: Props) => {
  const { t } = useTranslation();

  if (!dosageInstructions) return null;
  const strippedDosageInstructions = stripAttributesFromHTMLString(dosageInstructions, [
    "class",
    "style",
  ]);

  return (
    <GenericCollapsible header={t(l.productDetails.SuggestedUse)}>
      {/* eslint-disable-next-line @typescript-eslint/naming-convention */}
      <div dangerouslySetInnerHTML={{ __html: strippedDosageInstructions }} />
    </GenericCollapsible>
  );
};

export { SuggestedUse };
